import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../../layouts/CommonLayout';
import MeetingContainer from '../../containers/MeetingContainer';
import { getHostedMeetingList } from '../../../api/MeetingApi';
import useLoadingStore from '../../../store/loadingStore';
import { IoFlagOutline } from 'react-icons/io5';

const HostedMeetingListPage = () => {
    const navigate = useNavigate();
    const [meetings, setMeetings] = useState([]);
    const { setIsLoading } = useLoadingStore();

    useEffect(() => {
        fetchMeetings();
    }, []);

    const fetchMeetings = async () => {
        try {
            setIsLoading(true);
            const response = await getHostedMeetingList();
            setMeetings(response);
        } catch (error) {
            console.error('내가 모임장인 모임 목록 조회 실패:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleMeetingClick = (meetingId) => {
        navigate(`/app/meetings/${meetingId}`);
    };

    const formatDate = (dateString) => {
        if (!dateString) return null;
        const date = new Date(dateString);
        return {
            time: date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' }),
            date: date.toLocaleDateString('ko-KR', { month: 'numeric', day: 'numeric' })
        };
    };

    return (
        <CommonLayout title="내가 모임장인 모임">
            <div className="p-4 max-w-lg mx-auto">
                {meetings.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-16">
                        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                            <IoFlagOutline size={40} className="text-blue-500" />
                        </div>
                        <p className="text-gray-600 text-lg font-medium mb-2">모임장인 모임이 없습니다</p>
                        <p className="text-gray-500 text-sm text-center">
                            새로운 모임을 만들어<br />
                            모임장이 되어보세요!
                        </p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {meetings.map(meeting => {
                            const dateTime = formatDate(meeting.scheduledAt);
                            return (
                                <MeetingContainer
                                    key={meeting.meetingId}
                                    title={meeting.title}
                                    imageId={meeting.imageId}
                                    imageUrl={meeting.imageUrl}
                                    location={meeting.placeName}
                                    currentMembers={meeting.memberCount}
                                    maxMembers={meeting.maxCapacity}
                                    time={dateTime?.time}
                                    date={dateTime?.date}
                                    status={meeting.status}
                                    onClick={() => handleMeetingClick(meeting.meetingId)}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </CommonLayout>
    );
};

export default HostedMeetingListPage;
